import { nToPx, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const firstCardClass = style({
  borderRadius: nToPx(themeVars.radius.md, themeVars.radius.md, 0, 0),
});

export const middleCardClass = style({
  borderRadius: 0,
});

export const lastCardClass = style({
  borderRadius: nToPx(0, 0, themeVars.radius.md, themeVars.radius.md),
});

export const loneCardClass = style({
  borderRadius: `${themeVars.radius.md}!important`,
});
